<div class="cart-counter-icon">
  <span class="btv-icon-cart theme-header__cart-icon"></span>
  <span class="cart-counter-icon__count theme-header__cart-icon-count" [class.animate]="isAnimating">
    {{ trackCount }}
  </span>
</div>
